import type { Token } from "@frend-digital/centra-types";
import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";
import { Err, Ok, Result } from "ts-results";
import type { CentraAddress } from "./schema";

export const updateShippingMethod = async ({
  shippingMethod,
  token,
  apiUrl,
}: {
  shippingMethod: string;
  token: Token;
  apiUrl: string;
}): Promise<Result<BaseSelectionResponse, Error>> => {
  const url = new URL(`${apiUrl}/shipping-methods/${shippingMethod}`);
  if (!token) {
    return Err(new Error("Token is not available"));
  }

  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "API-Token": token,
    },
  });

  const json = await response.json();

  if (!response.ok) {
    return Err(
      new Error(json.message || "Failed to update shipping method", {
        cause: json,
      })
    );
  }

  return Ok(json);
};

export const updateAddress = async <T extends CentraAddress>(
  { address, shippingAddress }: { address: T; shippingAddress?: T },
  { apiUrl, token }: { apiUrl: string; token: Token }
): Promise<Result<BaseSelectionResponse, Error>> => {
  if (!token) {
    return Err(new Error("Token is not available"));
  }

  const url = new URL(`${apiUrl}/payment-fields`);

  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "API-Token": token,
    },
    body: JSON.stringify({
      address,
      shippingAddress,
    }),
  });

  const json = await response.json();

  if (!response.ok) {
    return Err(
      new Error(json.message || "Failed to update address", {
        cause: json,
      })
    );
  }

  return Ok(json);
};
